import { createSlice, type PayloadAction } from "@reduxjs/toolkit"
import { type RootState } from "store/store"
import { type BillingState, type StripeEntitlementResponse } from "./types"

const initialState: BillingState = {
  entitlement: null,
  paywallOpen: false,
  portalUrl: "",
}

export const billingSlice = createSlice({
  name: "billing",
  initialState,
  reducers: {
    setBillingEntitlement: (state, action: PayloadAction<StripeEntitlementResponse | null>) => {
      state.entitlement = action.payload

      if (!action.payload?.requiresPortal) state.portalUrl = ""
      if (action.payload?.entitled) state.paywallOpen = false
    },
    setBillingPortalUrl: (state, action: PayloadAction<string>) => {
      state.portalUrl = action.payload.trim()
    },
    openBillingPaywall: (state) => {
      state.paywallOpen = true
    },
    closeBillingPaywall: (state) => {
      state.paywallOpen = false
    },
    clearBillingState: () => initialState,
  },
})

export const {
  clearBillingState,
  closeBillingPaywall,
  openBillingPaywall,
  setBillingEntitlement,
  setBillingPortalUrl,
} = billingSlice.actions

export const selectBillingState = (state: RootState) => state.billing
export const selectBillingEntitlement = (state: RootState) => state.billing.entitlement
export const selectBillingPaywallOpen = (state: RootState) => state.billing.paywallOpen
export const selectBillingPortalUrl = (state: RootState) => state.billing.portalUrl

export default billingSlice.reducer
